// Menü-Konstanten und Standard-Konfigurationen

export const DEFAULT_VERTICAL_MENU = [
  {
    id: "dashboard",
    name: "Dashboard",
    icon: "RiDashboardHorizontalLine",
    visible: true,
    locked: true,
    order: 0,
  },
  {
    id: "anfragen",
    name: "Anfragen",
    icon: "RiQuestionAnswerLine",
    visible: true,
    order: 1,
  },
  {
    id: "kontakte",
    name: "Kontakte",
    icon: "RiContactsLine",
    visible: true,
    order: 2,
  },
  {
    id: "auftraege",
    name: "Aufträge",
    icon: "RiCameraLine",
    visible: true,
    order: 3,
    children: [
      { id: "jobs", name: "Jobs", visible: true },
      { id: "hochzeiten", name: "Hochzeiten", visible: true },
      { id: "online-terminbuchung", name: "Online-Terminbuchung", visible: true },
    ],
  },
  {
    id: "schriftliches",
    name: "Schriftliches",
    icon: "RiFileLine",
    visible: true,
    order: 4,
    children: [
      { id: "angebote", name: "Angebote", visible: true },
      { id: "auftr-best", name: "Auftr.Best.", visible: true },
      { id: "rechnungen", name: "Rechnungen", visible: true },
      { id: "mailbox", name: "Mailbox", visible: true },
      { id: "anschreiben", name: "Anschreiben", visible: true },
      { id: "gutscheine", name: "Gutscheine", visible: true },
      { id: "belege", name: "Belege", visible: true },
      { id: "artikel", name: "Artikel", visible: true },
      { id: "notizen", name: "Notizen", visible: true },
    ],
  },
  {
    id: "kalender",
    name: "Kalender",
    icon: "RiCalendarLine",
    visible: true,
    order: 5,
  },
  {
    id: "locations",
    name: "Locations",
    icon: "RiMapPin2Line",
    visible: true,
    order: 6,
  },
  {
    id: "aufgaben",
    name: "Aufgaben",
    icon: "CheckSquare",
    visible: true,
    order: 7,
  },
  {
    id: "boards",
    name: "Boards",
    icon: "RiApps2Line",
    visible: true,
    order: 8,
  },
  {
    id: "lesezeichen",
    name: "Lesezeichen",
    icon: "RiHeart2Line",
    visible: true,
    order: 9,
  },
  {
    id: "newsletter",
    name: "Newsletter",
    icon: "RiMailLine",
    visible: true,
    order: 10,
  },
  {
    id: "auswertungen",
    name: "Auswertungen",
    icon: "RiLayoutBottomLine",
    visible: true,
    order: 11,
  },
  {
    id: "mailbox",
    name: "Mailbox",
    icon: "RiMailLine",
    visible: false,
    order: 12,
  },
  {
    id: "einstellungen",
    name: "Einstellungen",
    icon: "RiSettings3Line",
    visible: true,
    locked: true,
    order: 13,
  },
];

export const DEFAULT_HORIZONTAL_MENU = [
  {
    id: "dashboard",
    name: "Dashboard",
    icon: "RiDashboardHorizontalLine",
    visible: true,
    locked: true,
    order: 0,
  },
  {
    id: "kontakte",
    name: "Kontakte",
    icon: "RiContactsLine",
    visible: true,
    order: 1,
  },
  {
    id: "auftraege",
    name: "Aufträge",
    icon: "RiCameraLine",
    visible: true,
    order: 2,
    children: [
      { id: "anfragen", name: "Anfragen", visible: true },
      { id: "jobs", name: "Jobs", visible: true },
      { id: "hochzeiten", name: "Hochzeiten", visible: true },
      { id: "online-terminbuchung", name: "Online-Terminbuchung", visible: true },
    ],
  },
  {
    id: "schriftliches",
    name: "Schriftliches",
    icon: "RiFileLine",
    visible: true,
    order: 3,
    children: [
      { id: "angebote", name: "Angebote", visible: true },
      { id: "auftr-best", name: "Auftr.Best.", visible: true },
      { id: "rechnungen", name: "Rechnungen", visible: true },
      { id: "mailbox", name: "Mailbox", visible: true },
      { id: "anschreiben", name: "Anschreiben", visible: true },
      { id: "gutscheine", name: "Gutscheine", visible: true },
      { id: "belege", name: "Belege", visible: true },
      { id: "artikel", name: "Artikel", visible: true },
      { id: "notizen", name: "Notizen", visible: true },
    ],
  },
  {
    id: "kalender",
    name: "Kalender",
    icon: "RiCalendarLine",
    visible: true,
    order: 4,
  },
  {
    id: "sonstiges",
    name: "Sonstiges",
    icon: "RiMoreLine",
    visible: true,
    order: 5,
    children: [
      { id: "aufgaben", name: "Aufgaben", visible: true },
      { id: "boards", name: "Boards", visible: true },
      { id: "locations", name: "Locations", visible: true },
      { id: "lesezeichen", name: "Lesezeichen", visible: true },
      { id: "newsletter", name: "Newsletter", visible: true },
      { id: "auswertungen", name: "Auswertungen", visible: true },
    ],
  },
  {
    id: "mailbox",
    name: "Mailbox",
    icon: "RiMailLine",
    visible: false,
    order: 6,
  },
  {
    id: "einstellungen",
    name: "Einstellungen",
    icon: "RiSettings3Line",
    visible: true,
    locked: true,
    order: 7,
  },
];
